<script lang="ts">
    import { Accordion, AccordionItem, Card, Col, Image } from "sveltestrap";
    import { MyProfile } from "../../../utils/Constant/Constant";
    import TimeLineMutualFriends from "./TimeLineMutualFriends.svelte";
    import TimeLineActivityFeed from "./TimeLineActivityFeed.svelte";
    import MyProfileAccondion from "./MyProfileAccondion.svelte";
</script>
<Col xl="3" lg="12" md="5" class="xl-40 box-col-4">
    <div class="default-according style-1 job-accordion faq-accordion" >
        <Col xl="12">
          <Card>
            <Accordion>
                <AccordionItem active header={MyProfile}>
                    <div class="collapse show">
                        <MyProfileAccondion />
                    </div>
                </AccordionItem>
            </Accordion>
          </Card>
        </Col>
        <Col xl="12">
            <Card>
                <Image fluid class="mt-5" alt="" src="/assets/images/social-app/timeline-3.png" />
            </Card>
        </Col>
        <TimeLineMutualFriends />
        <TimeLineActivityFeed />
    </div>
</Col>